import React, { HTMLAttributes } from 'react';
import { withCheckerboardBackground } from '@cld/with-checkerboard-background';
import { StyledImageFit } from './CustomTransformationCardImage.styled';

export interface ImageWithCheckerboardBackgroundProps {
  imgProps: Partial<HTMLAttributes<HTMLImageElement>>;
  transformationName?: string;
  className?: string;
  showCheckerboard?: boolean;
}

const CheckeredImageFit = withCheckerboardBackground(StyledImageFit);

export const ImageWithCheckerboardBackground = ({
  imgProps,
  transformationName,
  className,
  showCheckerboard = true,
}: ImageWithCheckerboardBackgroundProps) => (
  <CheckeredImageFit showCheckerboard={showCheckerboard} className={className}>
    <img {...imgProps} alt={transformationName} />
  </CheckeredImageFit>
);
